import { Injectable, signal } from '@angular/core';

/** where the "Was ist die Krone?" hint opens (viewport coordinates of the clicked crown) */
export interface PremiumHintAnchor {
  left: number;
  top: number;
  bottom: number;
}

/**
 * One hint for all crowns: a click on any Stammgast crown opens it, rendered once at the
 * app root so it is never clipped by name fields or game panels.
 */
@Injectable({ providedIn: 'root' })
export class PremiumHintService {
  readonly anchor = signal<PremiumHintAnchor | null>(null);

  open(element: HTMLElement): void {
    const rect = element.getBoundingClientRect();
    this.anchor.set({ left: rect.left + rect.width / 2, top: rect.top, bottom: rect.bottom });
  }

  close(): void {
    this.anchor.set(null);
  }
}
